<template>
    <div>
        <!-- Dialog principal de configuração -->
        <v-dialog v-model="show" max-width="420" persistent>
            <v-card>
                <v-card-title class="pa-4 pb-2">
                    <v-icon left>mdi-tablet-cellphone</v-icon>
                    <span style="font-size: 16px;">{{ $t('tablet.configuracaoMesa') }}</span>
                    <v-spacer />
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <div class="text-h6 mb-1">{{ mesaAtualLabel }}</div>
                    <div class="caption grey--text">
                        {{ $t('tablet.trocarMesa') }}
                    </div>

                    <!--
                      SELEÇÃO DE MESA REMOVIDA DA WEB (jul/2026) — não é código esquecido.

                      A mesa passou a ser propriedade do aparelho: o app Android grava o
                      device_code nas suas prefs e remonta a URL do cardápio a cada boot.
                      Trocar por aqui só navegava (window.location.href) e valia até o
                      próximo reinício, quando o tablet voltava para a mesa do
                      provisionamento — e os pedidos passavam a cair na mesa errada sem
                      ninguém perceber.

                      Mantido comentado para o caso de o app deixar de ser o único cliente
                      desta tela (ex.: tablet rodando em navegador comum).

                    <v-select
                        v-model="selectedUuid"
                        :items="tablets"
                        item-text="mesa_label"
                        item-value="uuid"
                        label="Mesa"
                        outlined
                        dense
                        hide-details
                        class="mb-4"
                        :loading="loadingTablets"
                        :disabled="loadingTablets"
                        no-data-text="Nenhuma mesa cadastrada"
                    />

                    <v-text-field
                        v-model="password"
                        label="Senha"
                        type="password"
                        outlined
                        dense
                        hide-details
                        @keyup.enter="save"
                    />
                    -->
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-btn
                        v-if="isConfigured"
                        text
                        color="orange darken-2"
                        @click="dialogReserva = true"
                    >
                        <v-icon left small>mdi-calendar-check</v-icon>
                        {{ $t('tablet.reservarMesa') }}
                    </v-btn>
                    <v-spacer />
                    <v-btn text @click="close">{{ $t('tablet.fechar') }}</v-btn>

                    <!-- Botão Salvar removido junto da seleção de mesa (ver acima).
                    <v-btn
                        color="primary"
                        :loading="loading"
                        :disabled="!selectedUuid || !password"
                        @click="save"
                    >
                        Salvar
                    </v-btn>
                    -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Sub-dialog de reserva -->
        <v-dialog v-model="dialogReserva" max-width="360">
            <v-card>
                <v-card-title class="pa-4 pb-2">
                    <v-icon left>mdi-calendar-check</v-icon>
                    <span style="font-size: 16px;">{{ $t('tablet.reservarMesa') }}</span>
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-text-field
                        v-model="nomeReserva"
                        :label="$t('tablet.nomeClienteOpcional')"
                        outlined
                        dense
                        hide-details
                        autofocus
                        @keyup.enter="confirmarReserva"
                    />
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer />
                    <v-btn text @click="dialogReserva = false">{{ $t('geral.cancelar') }}</v-btn>
                    <v-btn color="primary" @click="confirmarReserva">{{ $t('envio.confirmar') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'TabletConfigDialog',

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        emp: {
            type: String,
            required: true,
        },
        isConfigured: {
            type: Boolean,
            default: false,
        },
        currentUuid: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        dialogReserva: false,
        nomeReserva: '',
    }),

    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },

        mesaAtualLabel() {
            const tablet = this.$store.state.tablet;
            if (!tablet?.mesa) return this.$t('tablet.mesaNaoConfigurada');
            return tablet.descricao
                ? `${this.$t('tablet.mesaN', { n: tablet.mesa })} — ${tablet.descricao}`
                : this.$t('tablet.mesaN', { n: tablet.mesa });
        },
    },

    methods: {
        /*
         * fetchTablets() e save() removidos junto da seleção de mesa na web (jul/2026).
         * Motivo no comentário do template: a troca só valia até o próximo reinício do
         * tablet, porque o app Android remonta a URL a partir das próprias prefs.
         * A troca agora é feita no painel do tablet, que persiste o device_code no
         * aparelho. Ver zaper-tablet/TABLET_APP_MELHORIAS_PLAN.md (Parte B).
         *
         * async fetchTablets() {
         *     this.loadingTablets = true;
         *     try {
         *         const { data } = await this.$http.get('tablets/list');
         *         if (data.type === 'warning') {
         *             this.notify(data.msg, 'warning');
         *             return;
         *         }
         *         this.tablets = (data.data || []).map(t => ({
         *             ...t,
         *             mesa_label: t.descricao
         *                 ? `Mesa ${t.mesa} — ${t.descricao}`
         *                 : `Mesa ${t.mesa}`,
         *         }));
         *     } catch (e) {
         *         this.notify('Erro ao carregar mesas', 'warning');
         *     } finally {
         *         this.loadingTablets = false;
         *     }
         * },
         *
         * async save() {
         *     if (!this.selectedUuid || !this.password) return;
         *     this.loading = true;
         *     try {
         *         const { data } = await this.$http.post('tablets/validate-password', {
         *             password: this.password,
         *         });
         *         if (data.type === 'warning') {
         *             this.notify(data.msg, 'warning');
         *             return;
         *         }
         *         window.location.href = `/${this.emp}/tablet/${this.selectedUuid}`;
         *     } catch (e) {
         *         this.notify('Erro ao salvar configuração', 'warning');
         *     } finally {
         *         this.loading = false;
         *     }
         * },
         */

        confirmarReserva() {
            this.dialogReserva = false;
            this.show = false;
            this.$emit('reservar', this.nomeReserva.trim());
            this.nomeReserva = '';
        },

        close() {
            this.show = false;
        },
    },
};
</script>
